/**
 * Gem: gem.png — +1 gem. Square (aspect 1).
 */
import { gameImageUrl } from "../../assets/game-image-urls.js";
import { getCachedImage } from "../../assets/image-cache.js";
import { RunGameObject } from "./GameObject.js";

function getGemImage() {
  return getCachedImage(gameImageUrl("gem"));
}

export class RunGem extends RunGameObject {
  constructor(bottomCenterPosition, slot, slotOffset, progress, width) {
    super(bottomCenterPosition, slot, progress, width);
    this.slotOffset = slotOffset != null ? slotOffset : 0;
  }
  getType() { return "gem"; }
  getAspectRatio() {
    var img = getGemImage();
    if (img && img.naturalWidth > 0) {
      return img.naturalWidth / img.naturalHeight;
    }
    return 1;
  }
  getDrawImage() {
    return getGemImage();
  }

  draw(ctx, pixelX, pixelY, pixelW, pixelH) {
    if (this.collected) return;
    var gemImg = getGemImage();
    var size = Math.min(pixelW, pixelH);
    var drawX = pixelX + (pixelW - size) / 2;
    var drawY = pixelY + (pixelH - size) / 2;
    ctx.save();
    if (gemImg) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(gemImg, drawX, drawY, size, size);
    } else {
      ctx.fillStyle = "#00ffff";
      ctx.fillRect(drawX, drawY, size, size);
    }
    ctx.restore();
  }
}